// src/utils/storagePaths.js
export const DEFAULT_ROOTS = {
  results: "results",
  // video: "videos",
  meta: "video_metadata",
};

// Leading timestamp convention: "<ts>-<uuid>.json"
export function tsFromNameOrNull(name = "") {
  const first = name.split("-")[0];
  const ts = Number(first);
  return Number.isFinite(ts) ? ts : null;
}

// Try to harvest a timestamp from common folder layouts:
// .../<uid>/<timestamp>/file.json or "<timestamp>-uuid.json"
export function bestEffortTimestamp({ fullPath, name }) {
  const byName = tsFromNameOrNull(name);
  if (byName) return byName;
  // look for .../<ts>/ in the path
  const parts = (fullPath || "").split("/").reverse();
  for (const p of parts) {
    const asNum = Number(p);
    if (Number.isFinite(asNum) && asNum > 1e12) return asNum; // looks like ms ts
  }
  return null;
}

export function classifyKindFromVariant(variant = "") {
  // console.log("classifyKindFromVariant", variant);
  const v = String(variant).toLowerCase();
  if (v.includes("forced") || v.includes("spirometry")) return "spirometry";
  if (v.includes("exertion")) return "exertion";
  return "unknown";
}
